import React from "react";
import constant from "../../constant";
import axios from "axios";
import { DateRangePicker } from "react-dates";
import { START_DATE, END_DATE } from "react-dates/constants";
import moment from "moment";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { LoadingComp } from "../../components/LoadingComp";

export default class BookboxComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      desk_count: 0,
      disable_calendar: 1,
      error_qty: "",
      show_loading: 1,
      block_dates: [],
      focusedInput: null,
      startDate: null,
      endDate: null,
      show_calc: "",
      // End

      from_date: "",
      to_date: "",
      from_time: "",
      to_time: "",
      long_term: "",
      disable_days: "",
      disable_dates: "",
      space_type: "",
      continue: 0,
      is_loggedin: 0,
      userid: "",
      total_whole: "",
      selected_days: 0,
      is_loader: 0,
      show_alert: ""
    };
  }

  componentDidMount() {
    const { en_id } = this.props;

    axios
      .get(`${constant.phpHost}action/booking.php`, {
        params: {
          todo: "block_leave",
          get_id_en: en_id
        }
      })
      .then(res => {
        this.setState({
          leave_days: res.data
        });
      });
  }

  handleQuantityChange = e => {
    const { space, en_id } = this.props;
    let desk_count = parseInt(e.target.value);

    let current_date = moment();

    this.setState({
      desk_count: desk_count,
      disable_calendar: 0,
      error_qty: "",
      show_loading: 0
    });

    if (space.space.type > 1) {
      let date_of_next_month = moment(current_date, "YYYY-MM-DD")
        .add(1, "M")
        .endOf("month");

      if (window.innerWidth <= 767) {
        date_of_next_month = moment(current_date, "YYYY-MM-DD").endOf("month");
      }

      this.check_for_block_time_by_dates(current_date, date_of_next_month, 0);
    } else {
      axios
        .get(`${constant.phpHost}action/booking.php`, {
          params: {
            todo: "block_booked_dates",
            en_id: en_id,
            desk_count: desk_count
          }
        })
        .then(res => {
          this.setState({
            block_dates: res.data,
            focusedInput: null,
            startDate: null,
            endDate: null,
            show_calc: ""
          });
        });
    }
  };

  check_for_block_time_by_dates = (startDate, endDate, show_error) => {
    const { space, en_id } = this.props;
    let _this = this;
    startDate = moment(startDate).format("YYYY-MM-DD");
    endDate = moment(endDate).format("YYYY-MM-DD");

    axios
      .get(`${constant.phpHost}action/booking.php`, {
        params: {
          todo: "check_for_block_time_by_dates",
          en_id: en_id,
          startDate: startDate,
          endDate: endDate,
          space_type: space.space.type
        }
      })
      .then(res => {
        if (res.data && res.data !== "") {
          let blocked_date = _this.state.block_dates.concat(res.data);

          _this.setState({
            show_alert:
              res.data.length > 2 && show_error === 2 ? "You cannot book" : "",
            block_dates: blocked_date
          });
        }

        _this.open_hours_from_time(startDate, endDate);
      });
  };

  open_hours_from_time = (startDate, endDate) => {
    const { space, en_id } = this.props;
    axios
      .get(`${constant.phpHost}action/booking.php`, {
        params: {
          todo: "fetch_time",
          en_id: en_id,
          startDate: startDate,
          endDate: endDate,
          space_type: space.space.type
        }
      })
      .then(res => {
        this.setState({
          start_time: res.data.st_time,
          end_time: res.data.en_time
        });
      });
  };

  onDatesChange = ({ startDate, endDate }) => {
    const { space } = this.props;
    let { focusedInput, block_dates, long_term, selected_days } = this.state;
    let show_alert = "";
    let endDate_ = this.state.endDate;

    if (focusedInput === END_DATE && endDate == null) {
      startDate = endDate;
      focusedInput = START_DATE;
    }

    if (long_term === 1) {
      if (focusedInput === START_DATE && startDate != null) {
        endDate = moment(startDate).add(selected_days - 1, "days");
      }

      if (focusedInput === END_DATE && endDate != null) {
        let diff = moment(endDate).diff(endDate_, "days");
        let toAddDays = Math.ceil(diff / selected_days) * selected_days;
        endDate = moment(endDate_).add(toAddDays, "days");
      }
    }

    if (this.check_if_blocked(startDate, endDate)) {
      show_alert = "You cannot book as days are not available3.";
      focusedInput = START_DATE;
      startDate = null;
      endDate = null;
    }

    this.setState(
      {
        focusedInput,
        startDate,
        endDate,
        show_alert: show_alert
      },
      space.space.type > 1
        ? this.check_for_block_time_by_dates(
            startDate,
            endDate,
            block_dates.length > 2 ? 2 : 0
          )
        : null
    );
  };

  check_validation = () => {
    if (this.state.desk_count === 0) {
      this.setState({
        error_qty: "Please select the quantity/attendees"
      });
      return false;
    }
    if (
      this.state.startDate == null ||
      this.state.endDate == null ||
      this.state.from_date == null ||
      this.state.to_date == null
    ) {
      this.setState({
        show_alert: "Please select both the dates",
        show_alert_out: "Please select dates"
      });
      return false;
    }

    if (this.props.space.space.type > 1) {
      if (this.state.from_time === "") {
        this.setState({
          show_alert: "Please select From time"
        });
        return false;
      }

      if (this.state.to_time === "") {
        this.setState({
          show_alert: "Please select To time"
        });
        return false;
      }

      if (parseInt(this.state.is_valid) > 0) {
        this.setState({
          show_alert: "You cannot book"
        });
        return false;
      } else {
        this.setState({
          show_alert: ""
        });
      }
    }

    return true;
  };

  is_valid_with_time = () => {
    axios
      .get(`${constant.phpHost}action/booking.php`, {
        params: {
          todo: "is_valid",
          from_date: moment(this.state.startDate).format("YYYY-MM-DD"),
          to_date: moment(this.state.endDate).format("YYYY-MM-DD"),
          from_time: this.state.from_time,
          to_time: this.state.to_time,
          en_id: this.props.en_id,
          space_type: this.props.space.space.type
        }
      })
      .then(res => {
        this.setState({
          is_valid: res.data
        });
      });
  };

  onHandleOk_new = () => {
    if (this.check_validation()) {
      this.setState({ is_loader: 1, show_calc: "" });

      var curr = localStorage.getItem("O_Auth");
      var currency = 1;

      if (curr && curr !== "") {
        currency = JSON.parse(curr).currency;
      }

      var check = localStorage.getItem("from_search");

      let c_values = "";
      let c_id = "";
      c_values = localStorage.getItem("O_Auth");

      if (c_values && c_values.length > 0) {
        c_values = localStorage.getItem("O_Auth");
        c_id = JSON.parse(c_values).id;
      }

      let IDCURRENT = check != null ? JSON.parse(check).cu_id : currency;

      var currenId = 1;
      if (c_id !== "") {
        currenId = IDCURRENT;
      }

      if (check != null) {
        if (JSON.parse(check).cu_id !== "") {
          currenId = JSON.parse(check).cu_id;
        } else {
          currenId = 1;
        }
      } else {
        currenId = currency;
      }

      var from_date = moment(this.state.startDate).format("YYYY-MM-DD");
      var to_date = moment(this.state.endDate).format("YYYY-MM-DD");

      if (this.props.space.space.type > 1) {
        from_date =
          moment(this.state.startDate).format("YYYY-MM-DD") +
          " " +
          this.state.from_time;
        to_date =
          moment(this.state.endDate).format("YYYY-MM-DD") +
          " " +
          this.state.to_time;
      }

      axios
        .get(`${constant.phpHost}action/booking.php`, {
          params: {
            todo: "fetch_calculation",

            from_date: from_date,
            to_date: to_date,
            disable_days: this.state.disable_days,
            disable_dates: this.state.disable_dates,
            desk_count: this.state.desk_count,
            en_id: this.props.en_id,
            def_cur: currenId
          }
        })
        .then(res => {
          this.setState(
            {
              show_calc: res.data.calculation,
              c_total_price: res.data.c_total_price,
              c_discount: res.data.c_discount,
              c_booked_days: res.data.c_booked_days,
              c_per_price: res.data.c_per_price,
              c_gran_total: res.data.c_gran_total,
              total_whole: res.data.total_whole,
              show_loading: 0,
              from_date: from_date,
              to_date: to_date,
              is_loader: 0,
              focusedInput: this.state.focusedInput_Need
            }
            // this.closePicker()
          );
        });
    }
  };

  store_values = () => {
    let login_values = localStorage.getItem("O_Auth");

    if (this.check_validation()) {
      var now = new Date().getTime();

      let user_currency = JSON.parse(login_values).currency;
      let user_id = JSON.parse(login_values).id;

      let booking_values = {
        en_id: this.props.en_id,
        from_date: this.state.from_date,
        to_date: this.state.to_date,
        desk_count: this.state.desk_count,
        currency: user_currency,
        booking_time: now,
        user_id: user_id
      };

      localStorage.setItem("booking_values", JSON.stringify(booking_values));
      let b_values = localStorage.getItem("booking_values");
      const formData = new FormData();
      formData.append("bookin_values", b_values);
      formData.append("todo", "save_booking_values");
      axios
        .post(`${constant.phpHost}action/booking.php`, formData)
        .then(function(res) {
          // console.log(res);
          window.location.href = res.data.payURL;
        });
    }
  };

  // redirect_page = () => {
  //   if (this.state.is_loggedin === 0) {
  //     window.location.href = "/login";
  //   } else {
  //     window.location.href = "/success";
  //   }
  // };

  isDayBlocked = momentDate => {
    const availableDates = this.state.leave_days;
    for (var k in availableDates) {
      if (momentDate.format("ddd") === availableDates[k]) return true;
    }
    const availableDates1 = this.state.block_dates;
    for (var l in availableDates1) {
      if (momentDate.format("YYYY-MM-DD") === availableDates1[l]) return true;
    }
    return false;
  };

  cancelChanges = () => {
    this.setState({
      startDate: null,
      endDate: null,
      focusedInput: null,
      show_calc: "",
      show_alert: ""
    });
  };

  applyChanges = () => {
    this.onHandleOk_new();
  };

  // clearDates = () => {
  //   this.setState({
  //     startDate: null,
  //     endDate: null,
  //     focusedInput: "startDate",
  //     show_calc: "",
  //     show_alert: ""
  //   });
  // };

  nextMonthClick = day => {
    var current_date = day;
    var date_of_next_month = moment(current_date, "YYYY-MM-DD").endOf("month");
    if (window.innerWidth > 767) {
      date_of_next_month = moment(current_date, "YYYY-MM-DD")
        .add(1, "M")
        .endOf("month");
    }

    this.check_for_block_time_by_dates(current_date, date_of_next_month, 0);
  };

  check_if_blocked = (startDate, endDate) => {
    const diff = moment(endDate).diff(startDate, "days") + 1;
    var is_blocked = false;
    for (let i = 0; i < diff; i++) {
      const checkDate = moment(startDate)
        .add(i, "d")
        .format("YYYY-MM-DD");

      if (this.state.block_dates.indexOf(checkDate) > -1) {
        is_blocked = true;
      }
    }
    return is_blocked;
  };

  handleFocusChange = focusedInput => {
    this.setState({ focusedInput_Need: focusedInput });

    if (focusedInput) {
      if (this.state.disable_calendar === 0 && this.state.desk_count > 0) {
        this.setState({
          focusedInput,
          selected_days: this.props.space.max_days,
          long_term: this.props.space.isLongTerms
        });
      } else {
        this.setState({
          error_qty: "Select quantity first"
        });
      }
    }
    // }
  };

  closePicker = () => {
    this.handleFocusChange(this.state.focusedInput_Need);
  };

  block_end_time_with_start_time = from_time => {
    axios
      .get(`${constant.phpHost}action/booking.php`, {
        params: {
          startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.state.endDate).format("YYYY-MM-DD"),
          todo: "block_end_time_with_start_time",
          en_id: this.props.en_id,
          space_type: this.props.space.space.type,
          from_time: from_time
        }
      })
      .then(res => {
        this.setState({
          end_time: res.data.en_time
        });
      });
  };

  select_time = (e, field) => {
    if (field === "from_time") {
      var startDate = moment(this.state.startDate).format("YYYY-MM-DD");
      var endDate = moment(this.state.endDate).format("YYYY-MM-DD");

      if (startDate === endDate) {
        this.setState({ from_time: e.target.value, to_time: "" }, function() {
          this.block_end_time_with_start_time(this.state.from_time);
        });
      } else {
        this.setState({ from_time: e.target.value }, function() {
          this.is_valid_with_time();
        });
      }
    }

    if (field === "to_time") {
      this.setState({ to_time: e.target.value }, function() {
        this.is_valid_with_time();
      });
    }

    if (this.state.from_time !== "" || this.state.to_time !== "") {
      this.setState({ show_alert: "" });
    }
  };

  renderDatePresets = () => {
    const { space } = this.props;
    return (
      <div className="DateRangePicker_picker5">
        {this.state.show_alert !== "" ? (
          <div className="color-red">{this.state.show_alert}</div>
        ) : null}

        {space.space.type > 1 ? (
          <div className="book_time">
            <select
              value={this.state.from_time}
              onChange={e => this.select_time(e, "from_time")}
              disabled={
                moment(this.state.startDate).format("YYYY-MM-DD") ===
                  "Invalid date" ||
                moment(this.state.endDate).format("YYYY-MM-DD") ===
                  "Invalid date"
                  ? "disabled"
                  : ""
              }
            >
              <option value="">Select From time</option>
              {this.state.start_time && this.state.start_time.length > 0
                ? this.state.start_time.map((st_time, i) => {
                    return (
                      <option
                        key={i}
                        className={
                          parseInt(st_time.is_block) === 1 ? "add_block" : null
                        }
                        disabled={
                          parseInt(st_time.is_block) === 1 ? true : null
                        }
                      >
                        {st_time.time}
                      </option>
                    );
                  })
                : null}
            </select>
            <span>to</span>
            <select
              value={this.state.to_time}
              onChange={e => this.select_time(e, "to_time")}
              disabled={
                moment(this.state.startDate).format("YYYY-MM-DD") ===
                  "Invalid date" ||
                moment(this.state.endDate).format("YYYY-MM-DD") ===
                  "Invalid date"
                  ? "disabled"
                  : ""
              }
            >
              <option value="">Select To time</option>
              {this.state.end_time && this.state.end_time.length > 0
                ? this.state.end_time.map((en_time, i) => {
                    return (
                      <option
                        key={i}
                        className={
                          parseInt(en_time.is_block) === 1 ? "add_block" : null
                        }
                        disabled={
                          parseInt(en_time.is_block) === 1 ? true : null
                        }
                      >
                        {en_time.time}
                      </option>
                    );
                  })
                : null}
            </select>
          </div>
        ) : null}

        <div className="popup_calendar_button">
          <button onClick={this.cancelChanges}>Close</button>
          <button
            className={this.state.show_alert === "" ? "" : "disable"}
            onClick={this.state.show_alert === "" ? this.applyChanges : null}
          >
            Apply
          </button>
        </div>
      </div>
    );
  };

  render() {
    let {
      focusedInput,
      startDate,
      endDate,
      desk_count,
      error_qty
    } = this.state;

    const { space } = this.props;

    const getQuantity = () => {
      let option = [];
      for (let i = 0; i <= space.space.quantity; i++) {
        option.push(
          <option key={i} value={i}>
            {i === 0 ? "Select quantity" : i}
          </option>
        );
      }
      return option;
    };

    return (
      <div>
        <div className="form-group">
          <label>Choose {space.space.type > 1 ? "People" : "Desk"}</label>
          <select onChange={this.handleQuantityChange} value={desk_count}>
            {getQuantity()}
          </select>
          <span className="color-red">{error_qty}</span>
        </div>

        <div className="form-group">
          <label>Choose a date and time</label>

          <DateRangePicker
            startDateId="startDate"
            endDateId="endDate"
            startDate={startDate}
            endDate={endDate}
            onDatesChange={this.onDatesChange}
            focusedInput={focusedInput}
            onFocusChange={this.handleFocusChange}
            minimumNights={0}
            numberOfMonths={window.innerWidth <= 767 ? 1 : 2}
            onNextMonthClick={this.nextMonthClick}
            withPortal={true}
            displayFormat="DD-MM-YYYY"
            isDayBlocked={this.isDayBlocked}
            renderCalendarInfo={this.renderDatePresets}
          />
        </div>

        {this.state.show_calc !== "" ? (
          <div
            className="form-group"
            dangerouslySetInnerHTML={{
              __html: this.state.show_calc
            }}
          />
        ) : null}

        <div className="popup_button">
          {this.state.is_loader === 1 ? (
            <button>
              <LoadingComp customStyle={{ padding: "0" }} />
            </button>
          ) : (
            <button onClick={this.store_values}>BOOK NOW</button>
          )}
        </div>
      </div>
    );
  }
}
